import Vue from '../main'

export const errorCodes = {
  PHONE_NUMBER_DUPLICATED: 10024,
  NAME_EMPTY: 10013,
  TEMPLATE_NAME_ALREADY_EXISTS: 1007011,
  TEMPLATE_UNSUBSCRIBE_TAG_NOT_FOUND: 1007032,
  WORKFLOW_INVALID_STATUS_UPDATE: 200017,
  MAX_PLAN_EMAIL_TEMPLATE_REACHED: 1007039,
  MAX_PLAN_USER_COUNT_REACHED: 6060,
  USER_NAME_EXCEEDS_MAXIMUM_LENGTH: 10044,
  USER_ALREADY_EXISTS: 10023,
  EMAIL_NOT_VALID: 10005,
}

export function handleErrorCode(errorCode) {
  switch (errorCode) {
    case errorCodes.PHONE_NUMBER_DUPLICATED:
      return Vue.$t('error.codes.PHONE_NUMBER_DUPLICATED')
    case errorCodes.NAME_EMPTY:
      return Vue.$t('error.codes.NAME_EMPTY')
    case errorCodes.TEMPLATE_NAME_ALREADY_EXISTS:
      return Vue.$t('error.codes.TEMPLATE_NAME_ALREADY_EXISTS')
    case errorCodes.TEMPLATE_UNSUBSCRIBE_TAG_NOT_FOUND:
      return Vue.$t('error.codes.TEMPLATE_UNSUBSCRIBE_TAG_NOT_FOUND')
    case errorCodes.WORKFLOW_INVALID_STATUS_UPDATE:
      return Vue.$t('error.codes.WORKFLOW_INVALID_STATUS_UPDATE')
    case errorCodes.MAX_PLAN_EMAIL_TEMPLATE_REACHED:
      return Vue.$t('error.codes.MAX_PLAN_EMAIL_TEMPLATE_REACHED')
    case errorCodes.MAX_PLAN_USER_COUNT_REACHED:
      return Vue.$t('error.codes.MAX_PLAN_USER_COUNT_REACHED')
    case errorCodes.USER_NAME_EXCEEDS_MAXIMUM_LENGTH:
      return Vue.$t('error.codes.USER_NAME_EXCEEDS_MAXIMUM_LENGTH')
    case errorCodes.USER_ALREADY_EXISTS:
      return Vue.$t('error.codes.USER_ALREADY_EXISTS')
    case errorCodes.EMAIL_NOT_VALID:
      return Vue.$t('error.codes.EMAIL_NOT_VALID')
    default:
      return Vue.$t('error.codes.DEFAULT')
  }
}

export function getErrorMessage(errorData) {
  const errorCode = errorData?.ErrorCode || errorData?.errorCode

  return {
    status: 'danger',
    text: handleErrorCode(errorCode),
  }
}
